// @archigraph r8DljQiU
import { Link } from 'react-router-dom';
import { Container } from '../ui/Container';

export function Footer() {
  return (
    <footer className="border-t border-border py-12 mt-auto" role="contentinfo">
      <Container>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-primary font-bold text-sm uppercase tracking-widest mb-3">
              <svg
                className="h-5 w-5"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path d="M8 24L16 8L24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="square" />
                <rect x="14" y="6" width="4" height="4" fill="currentColor" />
                <rect x="6" y="22" width="4" height="4" fill="currentColor" />
                <rect x="22" y="22" width="4" height="4" fill="currentColor" />
              </svg>
              archigraph
            </Link>
            <p className="text-xs text-text-lighter leading-relaxed">
              Architecture diagrams that generate code.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-text-light font-bold mb-3">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/download" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Download
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Docs
                </Link>
              </li>
              <li>
                <Link to="/signup" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Sign up
                </Link>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-text-light font-bold mb-3">Community</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://github.com/archigraph" target="_blank" rel="noopener noreferrer" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  GitHub
                </a>
              </li>
              <li>
                <a href="https://twitter.com/archigraph" target="_blank" rel="noopener noreferrer" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Twitter
                </a>
              </li>
              <li>
                <a href="https://discord.gg/archigraph" target="_blank" rel="noopener noreferrer" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Discord
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-text-light font-bold mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Privacy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-xs text-text-lighter hover:text-primary transition-colors">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border">
          <p className="text-xs text-text-lighter text-center">
            &copy; {new Date().getFullYear()} ArchiGraph
          </p>
        </div>
      </Container>
    </footer>
  );
}
